export const AVANT_CITIES_ACCESS_TOKEN = '@ay-pia-web-ACToken';

export enum AvantCitiesEndpoints {
  GetApplicationMarketData = 'GetApplicationMarketData',
}

export type RegionData = {
  marketData?: {
    regionGeoJsonUrl?: string;
    censusTractsGeoJsonUrl?: string;
  };
};
